import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

import { getColor } from '../../common/UICommon';
import { TabletWidth } from '../../../global.style';

export const InfoV1Ver2Screen = styled.div<{ imgDesktop: string; imgMobile: string }>`
  background-image: url(${({ imgDesktop }) => imgDesktop});
  background-size: cover;
  background-position: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: left;

  @media (max-width: ${TabletWidth}px) {
    align-items: flex-end;
    justify-content: space-between;

    background-image: url(${({ imgMobile }) => imgMobile});
    background-position: top;
  }
`;

const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

export const InfoV1Ver2HeaderWrapper = styled.div`
  animation: ${fadeIn} 1s ease-in;
`;

export const InfoV1Ver2ScreenContentWrapper = styled.div`
  max-width: 427px;
  text-align: left;
  margin-left: 90px;
  animation: ${fadeIn} 1s ease-in;

  @media (max-width: ${TabletWidth}px) {
    max-width: 100%;
    flex-wrap: wrap;
    margin: 0;
    padding: 70px 24px 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const InfoV1Ver2ScreenTexts = styled.div`
  margin-bottom: 52px;

  @media (max-width: ${TabletWidth}px) {
    margin-bottom: 32px;
    margin: auto 0;
  }
`;

export const InfoV1Ver2ScreenTitle = styled.h3`
  font-family: Lora;
  font-size: 42px;
  font-weight: 600;
  line-height: 53px;
  color: ${getColor('WHITE')};
  margin-bottom: 14px;
`;

export const InfoV1Ver2ScreenDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
  color: ${getColor('WHITE')};
`;

export const InfoV1Ver2ScreenEmail = styled.a`
  margin-top: 10px;
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  display: block;
  text-decoration: none;

  color: ${getColor('GRAY_5')};
`;

export const InfoV1Ver2ScreenButtonWrapper = styled.div`
  width: 205px;

  @media (max-width: ${TabletWidth}px) {
    width: 100%;
  }
`;